// extracted by mini-css-extract-plugin
module.exports = {"container":"VehicleListDownloadCsv_container__dEm7Z"};